import React from 'react';
import styled from 'styled-components';


const StyledComponent = styled.div`
  footer{
    width: 100%;
    display: inline-block;
    background-color: var(--color-azul);
    padding: 20px 0px;
}

.sec-patrocinador{
    margin-bottom: 40px;
    &:last-child{
        margin-bottom: 0px;
    }
}
.p-nv1{
    max-height: 185px;
    max-width: 200px;
    margin:0 auto;
    display: block;
    width:100%;
}
.p-nv2{
    max-height: 92px;
    max-width: 118px;
    margin:0 auto;
    display: block;
    width:100%;
}
.p-nv3{
    max-height: 92px;
    max-width: 118px;
    margin:0 auto;
    display: block;
    width:100%;
}

.titulo-h1{
    display: flex;
    width:100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
    position: relative;
    &:before{
        content:"";
        width:100%;
        position: absolute;
        height: 1px;
        background-color: var(--color-rojo);
    }
    & h2{
        background-color: #ffffff;
        position: relative;
        z-index: 2;
        padding: 15px 15px;
        color:var(--color-azul);
        & span{
            color:var(--color-rojo);
        }
    }
}

.social-links{
    display: flex;
    position: relative;
    width:100%;
    list-style: none;
    justify-content: space-around;
    padding:0px;
    margin:0px;
    & img{
        filter: invert(100%) sepia(0%) saturate(7442%) hue-rotate(346deg) brightness(120%) contrast(117%);
        opacity: .5;
        transition: all .3s ease-in-out;
    }
    & img:hover{
        filter: invert(21%) sepia(78%) saturate(1909%) hue-rotate(346deg) brightness(114%) contrast(93%);
        opacity: 1;
    }
}

.tit-footer{color:#ffffff; font-weight: 800;
    @media (max-width: 600px) {
        text-align: center;
    }
}
.desc-footer{color:#787878; text-align: justify;
    @media (max-width: 600px) {
        text-align: center;
    }

}

.nav-link{
            font-size: 14px;
            color: rgb(186, 186, 186);
            &:hover{
                color:var(--color-rojo);
                transition: all .3s ease-in-out;
            }
          }  


.copyright{
    color:#ffffff;
    text-align: right;
    float:right;
    text-align: center;
    width: 100%;
    & span{
        color:#787878;
    }
}

.sep-footer{
    background-color: rgba(255,255,255,.10);
}
.logo-footer{
  height: 98px; margin: 0 auto; display: block;
}
.link-white{
  color:#ffffff;
}
 
`


export default  () => (
    <StyledComponent>
        <footer className="footer">
            <div className="section bg-blue sep-25">
                <div className="container ">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12">
                            <div className="row">
                  
                                <div className="col-xs-12 col-sm-4 col-md-4 mt-2 mb-2">
                                    <h4 className="tit-footer">ATLÉTICO DE SAN LUIS</h4>
                                    <div className="row">
                                        <div className="col-12 desc-footer">
                      Camino a la Presa de San José S/N, <br/>  
                      Colonia Rinconada de los Andes. CP 78413 <br/>
                      San Luis Potosí, San Luis Potosí.
                                        </div>
                                    </div>
                                </div>

                  

                                <div className="col-xs-12 col-sm-4 col-md-4 mt-2 mb-2">
                                    <img className="img-fluid mx-auto logo-footer" src="https://storage.atleticodesanluis.mx/files/311_escudo-blanco-2.png" height="200px" />
                                </div>


                                <div className="col-xs-12 col-sm-4 col-md-4 mt-2 mb-2">
                                    <ul className="social-links">
                                        <li><a href="https://www.facebook.com/AtletideSanLuis" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/facebook.png" alt="Facebook" /></a></li>
                                        <li><a href="https://www.instagram.com/atletidesanluis/" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/instagram.png" alt="Instagram" /></a></li>
                                        <li><a href="https://twitter.com/AtletideSanLuis" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/twitter.png" alt="Twitter" /></a></li>	
                                        <li><a href="https://vm.tiktok.com/ZMLhykVNU/" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/tik-tok.png" alt="TikTok" /></a></li>	
                                        <li><a href="https://www.youtube.com/channel/UCF-kaaSSk9rBEHa9MsfsGjA" target="_blank"><img src="https://atleticodesanluis.mx/img/footer/redes/youtube.png" alt="Youtube" /></a></li>
                                    </ul>
                                </div>
                  

                  
                            </div>
              
                        </div>
                    </div>    
                    <div className="container">
                        <hr className="sep-footer" />
                    </div>  
                    <div className="container">
            
                        <div className="row ">
                            <div className="col-xs-12 col-sm-12">
                                <span className="copyright">
                                    <a className="link-white" href="https://atleticodesanluis.mx/contenidos/aviso-de-privacidad">Aviso de privacidad</a>. 
                                    <span>Copyright © 2022</span> All Rights Reserved.  V{process.env.REACT_APP_VERSION?.replace(/.[0-9]*$/gm,'')}
                                </span>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        
    </StyledComponent>
)